import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';

import { CtaLink } from '../../components/cta';
import createImageUrl from '../../helpers/createImageUrl';
import Background from './background';
import Title from './title';
import Button from './button';
import Clock from './clock';

const dateInPast = (date) => {
  if (date.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
    return true;
  }

  return false;
};

const SignUpInner = styled.div`
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const CTA = ({
  htmlTitle,
  date,
  buttonLink,
  buttonText,
}) => {
  const showDeadline = !dateInPast(new Date(date));
  return (
    <Background
      image={createImageUrl({
        image: 'https://res.cloudinary.com/htkgpamks/image/upload/v1564139604/social-stain_ygn8w3.svg',
        options: ['w_370', 'c_limit', 'c_fill'],
      })}
    >
      <Container small>
        <SignUpInner>
          <div>
            {(date && showDeadline) ? <Clock deadline={date} /> : (
              <Title>
                <Content $content={htmlTitle} />
              </Title>
            )}
          </div>
          <Button outlineWhite to={buttonLink}>
            {buttonText}
          </Button>
        </SignUpInner>
      </Container>
    </Background>
  );
};

export default CTA;
